import { useState } from "react";

const ERROR_POLL_MS = 60_000;

// WHY: RTK Query polls at full rate through errors, so a 5xx would become a tight retry loop.
export const usePollingBackoff = (intervalMs: number) => {
	const [pollingInterval, setPollingInterval] = useState(intervalMs);

	const backOffOnError = (isError: boolean) => {
		const next = isError ? Math.max(intervalMs, ERROR_POLL_MS) : intervalMs;
		if (next !== pollingInterval) {
			setPollingInterval(next);
		}
	};

	return [pollingInterval, backOffOnError] as const;
};
